import React, { useEffect, useState } from 'react'
import Header from './Header/Header'
import Content from './Content/Content'
import Footer from './Footer/Footer'
import useViewport from '../../hooks/useViewport'
import Navlist from './Navlist/Navlist'
import {insert_adv,remove_adv} from '../../method/adv'

export default function Home() {
  // const {width} = useViewport();

  const [navFlag, setNavflag] = useState(false);
  const setNav = () => {
    navFlag ? setNavflag(false) : setNavflag(true);
  }


  return (
    <div className='blog'>
      <Header setNav={setNav} />
      <Navlist flag={navFlag} setNav={setNav} />
      <Content flag={navFlag} />
      <Footer />
    </div>
  )
}
